export const READABILITY_THRESHOLD = 168;
export const LUMINANCE_RED = .299;
export const LUMINANCE_GREEN = .587;
export const LUMINANCE_BLUE = .114;

export const extractRGB = raw => [
    (raw >> 16) & 0xFF,
    (raw >> 8) & 0xFF,
    raw & 0xFF,
];

export const luminance = raw => {
    const rgb = extractRGB(raw);
    return rgb[0] * LUMINANCE_RED
         + rgb[1] * LUMINANCE_GREEN
         + rgb[2] * LUMINANCE_BLUE;
};

export const weightedNumber = (num1, num2, weight) => {
    weight = Math.min(1, Math.max(0, weight));
    return Math.round((num1 * weight) + (num2 * (1 - weight)));
};

export const weighted = (raw1, raw2, weight) => {
    const rgb1 = extractRGB(raw1),
        rgb2 = extractRGB(raw2);
    return (weightedNumber(rgb1[0], rgb2[0], weight) << 16)
        | (weightedNumber(rgb1[1], rgb2[1], weight) << 8)
        | weightedNumber(rgb1[2], rgb2[2], weight);
};

export const text = raw => luminance(raw) > READABILITY_THRESHOLD ? 0 : 0xFFFFFF;

export const shaded = (raw, offset) => {
    if(offset == 0)
        return raw;

    let dir = 0xFFFFFF;
    if(offset < 0) {
        dir = 0;
        offset *= -1;
    }

    return weighted(dir, raw, offset);
};

export const hexByte = raw => {
    let str = raw.toString(16).substring(0, 2);
    return str.length < 2
        ? `0${str}` : str;
};

export const hex = raw => {
    let str = raw.toString(16).substring(0, 6);
    if(str.length < 6)
        str = '000000'.substring(str.length) + str;
    return `#${str}`;
};

export const fromHex = str => {
    while(str.substring(0, 1) === '#')
        str = str.substring(1);
    str = str.substring(0, 6);

    if(str.length === 3)
        str = str.substring(0, 1) + str.substring(0, 1)
            + str.substring(1, 2) + str.substring(1, 2)
            + str.substring(2, 3) + str.substring(2, 3);

    if(str.length !== 6)
        throw 'not a valid hex string';

    return parseInt(str, 16);
};
